export default window.CONTENT_INDEX;